import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const myHrAddPermissionValidToState = atom({
  key: "myHrAddPermissionValidToState",
  default: {
    value: "",
    error: false,
    errorText: "",
  },
  effects_UNSTABLE: [ocPersistAtom],
});
